/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ReplyListContainerLast_viewer = {
    readonly id: string;
    readonly " $fragmentRefs": FragmentRefs<"LocalReplyListContainer_viewer" | "ReplyListContainerLastFlattened_viewer">;
    readonly " $refType": "ReplyListContainerLast_viewer";
};
export type ReplyListContainerLast_viewer$data = ReplyListContainerLast_viewer;
export type ReplyListContainerLast_viewer$key = {
    readonly " $data"?: ReplyListContainerLast_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"ReplyListContainerLast_viewer">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "flattenReplies"
        }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ReplyListContainerLast_viewer",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "condition": "flattenReplies",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "LocalReplyListContainer_viewer"
                }
            ]
        },
        {
            "condition": "flattenReplies",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ReplyListContainerLastFlattened_viewer"
                }
            ]
        }
    ],
    "type": "User",
    "abstractKey": null
} as any);
(node as any).hash = '9a60fc8f5527c64f8391dfa59511b83d';
export default node;
